import { ActionsColumnValues, State } from '../../common/constants';
import { translateFn } from '../../../utils/translator.helper';
import { RiskManagementSideMenuEvents } from '../../sideMenus/common/common';
import { selectColumnRenderer } from '../../common/customRenderers';
import { html } from 'lit';

export function cvesRenderer(rowData) {
  return html`<span class="cell-label"> ${rowData?.item?.cves.length} </span>`;
}

export function actionsColumnRenderer(rowData) {
  if (!rowData.item.company.specifics.features.iorUsable) {
    return selectColumnRenderer.call(this, rowData, []);
  }

  const options = [] as Array<any>;

  if (rowData.item.state === State.IGNORED) {
    options.push({
      title: translateFn('Restore ignored application'),
      value: ActionsColumnValues.RESTORE,
      event: {
        name: RiskManagementSideMenuEvents.RESTORE_APPLICATIONS,
        detail: {
          companyId: rowData.item.company._id,
          applicationsIds: [rowData.item._id],
        },
      },
    });
  } else {
    options.push({
      title: translateFn('Ignore application'),
      value: ActionsColumnValues.IGNORE,
      event: {
        name: RiskManagementSideMenuEvents.IGNORE_APPLICATIONS,
        detail: {
          companyId: rowData.item.company._id,
          applicationsIds: [rowData.item._id],
        },
      },
    });
  }

  return selectColumnRenderer.call(this, rowData, options);
}
